
import React, { useState, useEffect, useContext } from "react";
import useForm from "../../../services/UseForm";
import validate from '../../../validations/admin/product/UploadImageSchema';
import {storage} from '../../../firebase';
import axios from "axios";
import { API } from "../../../services/api";
import '../../../css/UploadImg.css';
import ProgressBar from "../../../components/ProgressBar";
import { ProgressBarContext } from "../../../App";
import "bootstrap/dist/css/bootstrap.min.css";
import {UserContext } from "../../../App";

axios.defaults.baseURL = API;

function UploadImgProduct() {
    const {userID, showForm, setShowForm, setshowSubmenu} = useContext(UserContext);
    const [image , setImage] = useState(null);
    const [data, setData] = useState([])
    const [Barcode, setBarcode] = useState(null);
    const [ProductName, setProductName] = useState(null);
    const [ProductID, setProductID] = useState(null);
    const {setShowProgressBar, setProgress} = useContext(ProgressBarContext);
    const [imagePreview, setImagePreview] = useState(null);

    const handleImageChange = (event) => {
        const file = event.target.files[0]; // Get the selected file
        if (file) {
            setImage(event.target.files[0]);
            handleChange("Image", event.target.files[0].name);
            const objectUrl = URL.createObjectURL(file);
            setImagePreview(objectUrl);
        } else {
            setImage(null);
            handleChange("Image", "");
        }
    };

    const UpdateProductImgUrl = async () => {
        setShowProgressBar(true);
        setProgress(30); 
        try {
            let token = localStorage.getItem("token");
            const formData = new FormData();
                  formData.append('image', image);

        setProgress(70);
        await axios.put(`/UploadProductImage/${ProductID}`, formData, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
           let temOrder = response?.data;
            getImageProduct();
        }).catch((err) => {
            console.log(err);
        });
        
        setProgress(100);
        } catch (error) {
            console.error('API Error:', error);
        } finally {
            setShowProgressBar(false);
            setProgress(0);
        }
    };


    async function getImageProduct () {
        if(ProductID){
            let token = localStorage.getItem("token");

             await axios.put(`/getImageProductByProductID/${ProductID}`, { responseType: 'blob' }) // 1. Force blob response
            .then((response) => {
                let temOrder = response?.data;
                setImagePreview(temOrder.url);
            })
            .catch((error) => console.error('Error fetching image:', error)); 
        } 
    }

    async function handleSearchProduct (e) {
      let token = localStorage.getItem("token");
      setBarcode(e.target.value);
        if(e.target.value){
            var data = {
                Barcode: e.target.value
            }
            await axios.post("/getProductByBarcode", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
                let productData = response?.data;
                if(productData.length > 0){
                    setProductID(productData[0].ProductID);
                    handleChange("ProductID", productData[0].ProductID);
                    setProductName(productData[0].LaoName);
                    getImageProduct();
                } else {
                  handleChange("ProductID", null);
                  setProductID(null);
                  setProductName(null);
                }
            }).catch((err) => {
                console.log(err);
            });
        } else {
          setBarcode("");
        }
    }

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
} = useForm(UpdateProductImgUrl, validate);
const handleclickBack = () => {
        setShowForm(false);
        setshowSubmenu(true);
    };
  
  useEffect(() => {
    let userData = localStorage.getItem("userData");
    if (userData) {
      let userRole = JSON.parse(userData);
      setData(userRole);
    }
  }, []);

  return (
    
    <div className="uploadimgform">
      <ProgressBar bgcolor="orange" progress='0'  height={30} />
          <div className="MainUploadContent">
            <div className="Header">
                <div className="title">
                    <span>Upload Product Image</span>
                </div>
            </div>
                <form onSubmit={handleSubmit} noValidate>
                    <div className="bodyheader">
                        <div className="barcode">
                            <div className="txtSearchProduct">
                                <input type="text" className={`input form-control ${errors.ProductID && 'is-invalid'}`} placeholder="Search" onChange={(e) => handleSearchProduct(e)} value={Barcode || ''}/>
                                {errors.ProductID && (
                                    <p className="invalid-feedback">{errors.ProductID}</p>
                                )}
                                <span>ITEM: {ProductName || "....."}</span>
                            </div>
                            <div className="btnContent">
                                <button type="submit" className="btn btn-primary">Upload</button>
                                <button className="btn btn-danger" onClick={() => handleclickBack()} >Back</button>
                            </div>  
                        </div>
                        <div className="upload-img">
                            <input type="file" accept="image/*" className={`input form-control ${errors.Image && 'is-invalid'}`} onChange={(event)=> handleImageChange(event)}/>
                            <div className="product-img">
                               {imagePreview && (
                                    <img 
                                        src={imagePreview} 
                                        alt="Selected Preview" 
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </form> 
        </div>
    </div>
  );
};

export default UploadImgProduct;
